import { FC } from "react";
import { BuscarComponent } from "../../../../shared/providers/ListView/BuscarComponent";
import { InformeCuentaHeaderToolbar } from "./InformeCuentaHeaderToolbar";

export const InformeCuentaHeader: FC = () => {
    
    return (
        <div className='card-header border-0 py-4'>
            <BuscarComponent placeholder="Buscar" />
            <div className='card-toolbar'>
                <InformeCuentaHeaderToolbar />
            </div>
        </div>
    )
}